import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { adminApi } from "@/lib/auth";
import { errorText } from "@/lib/errors";
import { AdminShell } from "./AdminLogin";

const input = "mt-2 block w-full bg-transparent border-b border-pine/40 py-2 text-base normal-case tracking-normal focus:outline-none focus:border-brass transition-colors";

export default function AdminReset() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await adminApi.post("/auth/reset-password", { token: params.get("token") || "", password });
      setDone(true);
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AdminShell title="Choose a new password">
      {done ? (
        <div className="mt-8" data-testid="reset-done">
          <p className="rounded-2xl bg-paper p-5">Your password has been changed.</p>
          <Link to="/admin/login" className="mt-6 inline-block rounded-full bg-pine text-sage px-7 py-4" data-testid="reset-signin-link">Sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-10 grid gap-6" data-testid="reset-form">
          <label className="lb">New password (8+ characters)<input required minLength={8} type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={input} data-testid="reset-password-input" /></label>
          {error && <p className="text-sm text-red-800" data-testid="reset-error">{error}</p>}
          <button type="submit" disabled={busy} className="rounded-full bg-pine text-sage py-4 disabled:opacity-70" data-testid="reset-submit">{busy ? "Saving..." : "Save new password"}</button>
        </form>
      )}
    </AdminShell>
  );
}
